import React from 'react';
import { Form, Input, Button, Typography, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Api_VariavelGlobal, Cliente, Tipo_Cliente } from '../global';
import './LoginPage.css';

const { Title, Text } = Typography;

const Login = () => {
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      const payload = {
        EMAIL: values.EMAIL,
        SENHA: values.SENHA,
      };

      const response = await axios.post(`${Api_VariavelGlobal}/api/login-gestor`, payload);

      if (
        response.data.user &&
        response.data.user.ID_USUARIO &&
        (response.data.user.ID_TIPO_USUARIO === 1 || response.data.user.ID_TIPO_USUARIO === 2)
      ) {
        if (response.data.token) {
          sessionStorage.setItem('token', response.data.token);
        }
        sessionStorage.setItem('user', JSON.stringify(response.data.user));
        localStorage.setItem('userId', response.data.user.ID_USUARIO);

        //message.success('Login realizado com sucesso!');
        navigate('/');
      } else {
        message.error('Usuário não autorizado. Apenas administradores e colaboradores podem acessar.');
      }
    } catch (error) {
      const msg = error.response?.data?.message || 'Erro ao conectar com o servidor.';
      message.error(msg);
    }
  };

  return (
    <div className="login-wrapper">
      {/* Coluna Esquerda */}
      <div className="login-left">
        <div className="welcome-text">
          <Text className="ola">Olá {Cliente},</Text>
          <Title level={3} className="bem-vindo">seja bem-vindo!</Title>
        </div>
      </div>

      {/* Coluna Direita */}
      <div className="login-right">
        <div className="login-box">
            <img src="/logo-ejanz.png" alt="Logo" className="login-logo" />
            <Title level={4} className="login-title">Gestão Comercial</Title>
            <span>{Tipo_Cliente}</span>
            <Text className="login-subtitle">Insira os dados abaixo para entrar</Text>

          <Form name="login" onFinish={onFinish} layout="vertical">
            <Form.Item
              name="EMAIL"
              rules={[{ required: true, message: 'Por favor, insira seu email!' }]}
            >
              <Input placeholder="E-mail" size="large" />
            </Form.Item>

            <Form.Item
              name="SENHA"
              rules={[{ required: true, message: 'Por favor, insira sua senha!' }]}
            >
              <Input.Password placeholder="Senha" size="large" />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" block size="large" className="login-button">
                Login
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Login;
